import { render, staticRenderFns } from "./TableNormal.vue?vue&type=template&id=1bc23f65&scoped=true&"
import script from "./TableNormal.vue?vue&type=script&lang=js&"
export * from "./TableNormal.vue?vue&type=script&lang=js&"
import style0 from "./TableNormal.vue?vue&type=style&index=0&id=1bc23f65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc23f65",
  null
  
)

export default component.exports